import { $api } from '../../global';

export const getUniversityCourse = (id?: string) => async () => {
  const { data } = await $api.get('/university-course', {
    params: { university_id: id }
  });

  return data;
};
